"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const E = require("fp-ts/lib/Either");
const ssn = require("hetu-ts");
const _1 = require(".");
function ssnV(path) {
    return x => {
        const result = ssn.parse(x);
        return ssn.Result.isSuccess(result)
            ? E.right(x)
            : E.left([
                new _1.ValidationError(path, `${x} is invalid ssn`, new InvalidSsnInfo(x, result.message)),
            ]);
    };
}
exports.ssnV = ssnV;
class InvalidSsnInfo {
    constructor(actual, error) {
        this.actual = actual;
        this.error = error;
        this.type = 'invalidSsn';
    }
}
exports.InvalidSsnInfo = InvalidSsnInfo;
